import httpRequest from "./index";
import type { Page } from "../../../../common/types/base/BaseEntity";
import type { DeliveryVo, DeliveryPagingParams } from "@zhihaoscm/entity";

// 提货信息 分页查询
export async function deliveryCustomPaging(params: DeliveryPagingParams): Promise<Page<DeliveryVo>> {
    const { data } = await httpRequest.get("/delivery/custom-paging", { params });
    return data;
}

// 批量确认
export async function deliveryConfirm(params: string[]) {
    return await httpRequest.put("/delivery/confirm", params);
}

// 详情
export async function getDeliveryVo(id: string): Promise<DeliveryVo> {
    const { data } = await httpRequest.get(`/delivery/vo/${id}`);
    return data;
}
